import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbabf67c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indent" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = {
  key: 0,
  class: "directory"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-down" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-right" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "file"
}
const _hoisted_11 = { class: "name" }

import { ref, withDefaults, watch } from 'vue';

export interface PropsOptions {
	entry: IDESideBarContentTabFileSystem.FSEntry,
	level: number,
}


import * as IDESideBarContentTabFileSystem from './IDESideBarContentTabFileSystem.vue';
import * as FileIcon from '@/components/FileIcon.vue';

export const EmitsOptions = {
	'onClickFile' : (fileEntry: IDESideBarContentTabFileSystem.FSEntryFile) => {return true;},
	'onClickDirectory' : (directoryEntry: IDESideBarContentTabFileSystem.FSEntryDirectory) => {return true;},
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IDESideBarContentTabFileSystemTreeEntry',
  props: {
    entry: null,
    level: null
  },
  emits: EmitsOptions,
  setup(__props: any, { emit }) {

const props = __props as { entry: IDESideBarContentTabFileSystem.FSEntry, level: number }





function getEntryNameFromFilename(filename:string) {
	const parts = filename.split("/");
	return parts[parts.length - 1];
}

function onClick(entry:IDESideBarContentTabFileSystem.FSEntry) {
	if (entry.type == IDESideBarContentTabFileSystem.FSEntryType.directory) {
		emit('onClickDirectory', entry as IDESideBarContentTabFileSystem.FSEntryDirectory);
	}else if (entry.type == IDESideBarContentTabFileSystem.FSEntryType.file) {
		emit('onClickFile', entry as IDESideBarContentTabFileSystem.FSEntryFile);
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["entry", {
			file: __props.entry.type == IDESideBarContentTabFileSystem.FSEntryType.file,
			directory: __props.entry.type == IDESideBarContentTabFileSystem.FSEntryType.directory,
		}]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick(__props.entry))),
    style: _normalizeStyle({
			// nastaveni kvuli sticky slozkam
			top: `${__props.level * 25}px`,
			zIndex: 100 - __props.level,
		})
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["content", {
			active: __props.entry.type == IDESideBarContentTabFileSystem.FSEntryType.file && (__props.entry as IDESideBarContentTabFileSystem.FSEntryFile).active,
			openInEditor: __props.entry.type == IDESideBarContentTabFileSystem.FSEntryType.file && (__props.entry as IDESideBarContentTabFileSystem.FSEntryFile).openInEditor,
			openByLector: __props.entry.type == IDESideBarContentTabFileSystem.FSEntryType.file && (__props.entry as IDESideBarContentTabFileSystem.FSEntryFile).openByLector,
			isLectorActive: __props.entry.type == IDESideBarContentTabFileSystem.FSEntryType.file && (__props.entry as IDESideBarContentTabFileSystem.FSEntryFile).isLectorActive,
		}])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.level, (i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "guide",
            key: i
          }))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_2, [
        (__props.entry.type == IDESideBarContentTabFileSystem.FSEntryType.directory)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              ((__props.entry as IDESideBarContentTabFileSystem.FSEntryDirectory).expanded)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_9))
            ]))
          : (__props.entry.type == IDESideBarContentTabFileSystem.FSEntryType.file)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                _createVNode(FileIcon.default, {
                  filename: __props.entry.filename
                }, null, 8, ["filename"])
              ]))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, _toDisplayString(getEntryNameFromFilename(__props.entry.filename)), 1)
    ], 2)
  ], 6))
}
}

})